import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'highlight';
}
export function Card({
  children,
  className = '',
  variant = 'default'
}: CardProps) {
  const baseStyles = 'rounded-lg p-6 md:p-8 transition-all duration-300';
  const variants = {
    default: 'bg-charcoal-700/50 border border-charcoal-600/50',
    highlight: 'bg-gradient-to-br from-charcoal-700 to-charcoal-800 border border-amber-400/20 shadow-[0_4px_20px_-10px_rgba(212,165,116,0.15)]'
  };
  return <div className={`${baseStyles} ${variants[variant]} ${className}`} data-id="element-194">
      {children}
    </div>;
}